exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.main {\n  margin: 1ex;\n  padding: 1ex;\n  border: thick double #222;\n}\n\ndiv.button {\n  text-align: right;\n  margin: 0.6ex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/crossref-box/crossref-box.component.css
// module id = 383
// module chunks = 0